/**
 * UA(User-Agent/UA-CH)から端末種別を判定するユーティリティ
 *
 * 目的:
 * ・広告配信タイプ(PC用/SP用)が画面幅ではなくUAで決まる仕様に合わせる
 * ・「アプリで見る」などの導線表示を、PCでウィンドウを狭くしただけで出さない
 *
 * 注意:
 * ・画面幅(isTablet等)はレイアウト用であり、端末種別の判定には使わない
 * ・iPadOS13+はUAがMac寄りになることがあるため、タッチ情報で補助判定する
 */

function isAppleMobileLike() {
  // iPadOS13+や「デスクトップ用Webサイト」設定時にMacっぽく見えるケースの補助
  // Macは通常maxTouchPointsが0なので、ここでほぼ分離できる
  return navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 0;
}

export function isMobileUa() {
  if (typeof navigator === 'undefined') return false;

  // UA-CHは「trueならモバイル確定」として使い、「falseだから非モバイル」とは断定しない
  const uad = navigator.userAgentData;
  if (uad && typeof uad.mobile === 'boolean' && uad.mobile) {
    return true;
  }

  const ua = navigator.userAgent || '';

  // iOS/iPadOS
  if (isAppleMobileLike()) return true;
  if (/iPhone|iPod|iPad/.test(ua)) return true;

  // Android(phone/tabletを問わずモバイル系として扱う)
  if (/Android/.test(ua)) return true;

  return false;
}

export function isIOS() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  return /iPhone|iPod|iPad/.test(ua) || isAppleMobileLike();
}

export function isAndroid() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  return /Android/.test(ua);
}